import { muiStyles } from 'utils/design';

export const useStyles = muiStyles(() => ({
  paper: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    height: 0,
    overflowY: 'scroll',

    // CSP-safe triangle icons used as Ag-Grid expand/collapse markers for grouped/tree rows.
    '& .statGroupIcon': {
      display: 'inline-block',
      width: 0,
      height: 0,
      borderTop: '5px solid transparent',
      borderBottom: '5px solid transparent',
      borderLeft: '7px solid #6b7280',
      marginRight: 8,
      flex: '0 0 auto',
    },
    '& .statGroupIcon--expanded': {
      transform: 'rotate(90deg)',
    },
  },
}));
